import { call, put, select, takeLatest } from 'redux-saga/effects';
import { delay } from 'redux-saga'
import {
    GET_RECENT_MOVIES,
    GET_SOON_MOVIES,
    GET_MOVIE_DETAILS,
    ADD_MOVIE_TO_FAVORITE,
    REMOVE_MOVIE_FROM_FAVORITE,
    SEND_MOVIE_REVIEW,
    GET_SOON_IN_CINEMA_MOVIES,
    GET_MOVIE_TIME_SCHEDULE,
    GET_ALL_MOVIES,
    ADD_MOVIE_TO_FAVORITE_FROM_ALL_MOVIES,
    REMOVE_MOVIE_FROM_FAVORITE_FROM_ALL_MOVIES,
    GET_ALL_MOVIES_SEE_MORE,
    GET_RECENT_MOVIES_PAGE,
    ADD_MOVIE_TO_FAVORITE_FROM_RECENT_MOVIES,
    REMOVE_MOVIE_FROM_FAVORITE_FORM_RECENT_MOVIES,
    GET_RECENT_MOVIES_PAGE_SEE_MORE,
    ADD_MOVIE_TO_FAVORITE_FROM_HOME_RECENT_MOVIES,
    REMOVE_MOVIE_FROM_FAVORITE_FROM_HOME_RECENT_MOVIES,
    GET_SOON_IN_CINEMA_FILTERED_MOVIES,
    GET_MOVIES_SCHEDULE,
    GET_RECENT_MOVIES_SLIDER,
    REMOVE_MOVIE_FROM_FAVORITE_FROM_SCHEDULE,
    ADD_MOVIE_TO_FAVORITE_FROM_SCHEDULE,
    ADD_MOVIE_TO_FAVORITE_FROM_SCHEDULE_CAROUSEL_ITEM,
    REMOVE_MOVIE_TO_FAVORITE_FROM_SCHEDULE_CAROUSEL_ITEM,
    GET_RECOMMENDED_MOVIES,
    ADD_MOVIE_TO_FAVORITE_FROM_RECOMMENDED,
    REMOVE_MOVIE_FROM_FAVORITE_FROM_RECOMMENDED,
    ADD_MOVIE_TO_FAVORITE_FROM_BOX_OFFICE,
    REMOVE_MOVIE_FROM_FAVORITE_FROM_BOX_OFFICE,
    ADD_MOVIE_TO_FAVORITE_FROM_SOON_IN_CINEMA,
    REMOVE_MOVIE_FROM_FAVORITE_FROM_SOON_IN_CINEMA
} from "../actions/types";

import { showGeneralError, hideGeneralError } from '../actions/general.actions';
import {
    getSoonMoviesSucceeded,
    getMovieDetailsSucceeded,
    getRecentMoviesSucceeded,
    getSoonInCinemaMoviesSucceeded,
    getMovieTimeScheduleSucceeded,
    getAllMoviesSucceeded,
    getAllMoviesSeeMoreSucceeded,
    getRecentMoviesPageSucceeded,
    getRecentMoviesPageSeeMoreSucceeded,
    getSoonInCinemaFilteredMoviesSucceeded,
    getMovieScheduleSucceeded,
    getRecentMoviesSliderSucceeded,
    getRecommendedMoviesSucceeded,
    storeFilteredMovieScheduleSucceeded
} from '../actions/movies.actions';

import { moviesBoxOfficeSuccess } from '../actions/boxoffice.actions'
import {COMMENT_ADDED, GENERIC_ERROR_MESSAGE} from "../config/messages";
import {
    getSoonMovies,
    getRecentMovies,
    getMovieDetails,
    addMovieToFavorite,
    removeMovieFromFavorite,
    sendMovieReview,
    getSoonInCinemaMovies,
    getMovieTimeScheduler,
    getAllMovies,
    getAllMoviesSeeMore,
    getRecentMoviesPage,
    getRecentMoviesSeeMore,
    getSoonInCinemaFilteredMovies,
    getMovieSchedule,
    recentMoviesSlider,
    getRecommendedMovies
} from "../api/movies.api";

import { showSpinner, hideSpinner } from '../actions/loading.actions';
import { push } from "connected-react-router";
import { NOT_FOUND_ROUTE } from "../config/routes";
import { loginApiMessagesShow } from "../actions/user.actions";
import { requestScheduleMoviesAllSuccess, requestMoviesByCinemaSuccess, requestSortTypesOnCinemaSchedule } from "../actions/schedule.actions";

import {reset} from "redux-form";


function* getSoonMoviesSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getSoonMovies, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 200) {
            yield put(getSoonMoviesSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getRecentMoviesSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getRecentMovies, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 200) {
            yield put(getRecentMoviesSucceeded(response.data.rows));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getMovieDetailsSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getMovieDetails, action.payload);

        if (response.status) {
            yield put(hideSpinner());
        }

        if (response.status === 200) {
            yield put(getMovieDetailsSucceeded(response.data));
        }
    } catch (e) {
        if (e.message.substr(e.message.length - 3) === '404') {
            yield put(push(NOT_FOUND_ROUTE));
        } else {
            yield put(hideSpinner());
            yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
            yield call(delay, 5000);
            yield put(hideGeneralError(''));
        }


    }
}

function* getSoonInCinemaMoviesSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getSoonInCinemaMovies, action.payload);

        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 200) {
            yield put(getSoonInCinemaMoviesSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* addMovieToFavoriteSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(addMovieToFavorite, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 201) {
            const prevState = yield select(state => state.movies.movieDetails)
            const favMovie = { ...prevState, favorite: [{ uuid: response.data.data.id }] }
            yield put(getMovieDetailsSucceeded(favMovie));
        }
    } catch (e) {
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* removeMovieFromFavoriteSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(removeMovieFromFavorite, action.payload)
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 204) {
            const prevState = yield select(state => state.movies.movieDetails)
            const favMovie = { ...prevState, favorite: [] }
            yield put(getMovieDetailsSucceeded(favMovie));
        }
    } catch (e) {
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* sendMovieReviewSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(sendMovieReview, action.payload);

        if (response.status === 200){
            yield put(hideSpinner());
            yield put(showSpinner());
            const movieDetailsResponse = yield call(getMovieDetails, action.payload.film_id);
            if (movieDetailsResponse.status === 200) {
                yield put(hideSpinner());
                yield put(getMovieDetailsSucceeded(movieDetailsResponse.data));
            }
            yield put(reset('addCommentForm'));
            yield put(showGeneralError(COMMENT_ADDED));
            yield call(delay, 5000);
            yield put(hideGeneralError(''));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getMovieTimeSchedulerSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getMovieTimeScheduler, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 200) {
            yield put(getMovieTimeScheduleSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getAllMoviesSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getAllMovies, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 200) {
            yield put(getAllMoviesSucceeded(response.data))
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getAllMoviesSeeMoreSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getAllMoviesSeeMore, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 200) {
            const prevState = yield select(state => state.movies.allMovies);
            if (prevState.rows) {
                const movies = { ...prevState, rows: prevState.rows.concat(response.data.rows), pager: response.data.pager }
                yield put(getAllMoviesSeeMoreSucceeded(movies));
            }
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* addMovieToFavoriteFromAllMoviesSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(addMovieToFavorite, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 201) {
            const prevState = yield select(state => state.movies.allMovies);
            let index = prevState.rows.findIndex(element => element.film_uuid === action.payload);
            prevState.rows[index].favorite.push({ uuid: response.data.data.id });
            const addMovieToFav = { ...prevState };
            yield put(getAllMoviesSucceeded(addMovieToFav));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* removeMovieFromFavoriteFromAllMoviesSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(removeMovieFromFavorite, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 204) {
            const prevState = yield select(state => state.movies.allMovies);
            let index = prevState.rows.findIndex(element => element.film_uuid === action.filmId);
            prevState.rows[index].favorite = [];
            const removeMovieFromFav = { ...prevState }
            yield put(getAllMoviesSucceeded(removeMovieFromFav));

        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getRecentMoviesPageSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getRecentMoviesPage, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 200) {
            yield put(getRecentMoviesPageSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* addMovieToFavoriteFromRecentMoviesSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(addMovieToFavorite, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 201) {
            const prevState = yield select(state => state.movies.recentMoviesPage);
            let index = prevState.rows.findIndex(element => element.film_uuid === action.payload);
            prevState.rows[index].favorite.push({ uuid: response.data.data.id });
            const addMovieToFav = { ...prevState };
            yield put(getRecentMoviesPageSucceeded(addMovieToFav));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* removeMovieFromFavoriteFromRecentMoviesSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(removeMovieFromFavorite, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 204) {
            const prevState = yield select(state => state.movies.recentMoviesPage);
            let index = prevState.rows.findIndex(element => element.film_uuid === action.filmId);
            prevState.rows[index].favorite = [];
            const removeMovieFromFav = { ...prevState }
            yield put(getRecentMoviesPageSucceeded(removeMovieFromFav));

        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getRecentMoviesPageSeeMoreSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getRecentMoviesSeeMore, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 200) {
            const prevState = yield select(state => state.movies.recentMoviesPage);
            if (prevState.rows) {
                const movies = { ...prevState, rows: prevState.rows.concat(response.data.rows), pager: response.data.pager }
                yield put(getRecentMoviesPageSeeMoreSucceeded(movies));
            }
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* addMovieToFavoriteFromHomeRecentMoviesSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(addMovieToFavorite, action.payload.film_id);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 201) {
            if (action.payload.view === "recentMovies") {
                let prevState = yield select(state => state.movies.recentMovies)
                let index = prevState.findIndex(element => element.film_uuid === action.payload.film_id);
                prevState[index].favorite.push({ uuid: response.data.data.id });
                const addMovieToFav = [...prevState];
                yield put(getRecentMoviesSucceeded(addMovieToFav));
            }
            else {
                let prevState = yield select(state => state.movies.soonMovies)
                let index = prevState.findIndex(element => element.film_uuid === action.payload.film_id);
                prevState[index].favorite.push({ uuid: response.data.data.id });
                const addMovieToFav = [...prevState];
                yield put(getSoonInCinemaMoviesSucceeded(addMovieToFav));
            }
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* removeMovieFromFavoriteFromHomeRecentMoviesSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(removeMovieFromFavorite, action.payload.uuid);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 204) {
            if (action.payload.view === "recentMovies") {
                let prevState = yield select(state => state.movies.recentMovies)
                let index = prevState.findIndex(element => element.film_uuid === action.payload.film_uuid);
                prevState[index].favorite = [];
                const removeMovieFromFav = [...prevState]
                yield put(getRecentMoviesSucceeded(removeMovieFromFav));
            }
            else {
                let prevState = yield select(state => state.movies.soonMovies)
                let index = prevState.findIndex(element => element.film_uuid === action.payload.film_uuid);
                prevState[index].favorite = [];
                const removeMovieFromFav = [...prevState]
                yield put(getSoonInCinemaMoviesSucceeded(removeMovieFromFav));
            }
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getSoonInCinemaFilteredMoviesSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getSoonInCinemaFilteredMovies, action.payload);

        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 200) {
            const dada = {
                current_date: action.payload,
                resp: response.data
            }

            yield put(getSoonInCinemaFilteredMoviesSucceeded(dada));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* addMovieToFavoriteFromScheduleSaga(action) {
    try {
        yield put(showSpinner());

        const response = yield call(addMovieToFavorite, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        let favoriteId = response.data.data.id;
        if (response.status === 201) {
            let prevState = yield select(state => state.schedule.scheduleAllMovies);

            prevState.forEach(item => {
                if (item.film.film_uuid === action.payload) {
                    item.film.favorite.push({ uuid: favoriteId });
                }
            });
            let response = [...prevState];

            yield put(requestScheduleMoviesAllSuccess(response));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* removeMovieFromFavoriteFromScheduleSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(removeMovieFromFavorite, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }

        if (response.status === 204) {
            let prevState = yield select(state => state.schedule.scheduleAllMovies);
            prevState.forEach(item => {
                if (item.film.favorite.length > 0) {
                    if (item.film.favorite[0].uuid === action.payload) {
                        item.film.favorite = [];
                    }
                }
            });
            let response = [...prevState];
            yield put(requestScheduleMoviesAllSuccess(response));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getMovieScheduleSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getMovieSchedule, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 200) {
            yield put(getMovieScheduleSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}


function* getRecentMoviesSliderSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(recentMoviesSlider, action.payload);

        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 200) {
            yield put(getRecentMoviesSliderSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* addMovieToFavoriteFromScheduleCarouselItemSaga(action) {
    try {
        yield put(showSpinner());

        const response = yield call(addMovieToFavorite, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        let favoriteId = response.data.data.id;
        if (response.status === 201) {
            let prevState = yield select(state => state.schedule.movies);

            prevState.forEach(item => {
                item.schedule.forEach(sc => {
                    if (sc.film.film_uuid === action.payload) {
                        sc.film.favorite.push({ uuid: favoriteId });
                    }
                })
            });
            let cinemas = [...prevState];

            yield put(requestMoviesByCinemaSuccess(cinemas));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* removeMovieFromFavoriteFromScheduleCarouselItemSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(removeMovieFromFavorite, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }

        if (response.status === 204) {
            let prevState = yield select(state => state.schedule.movies);
            prevState.forEach(item => {
                item.schedule.forEach(sc => {
                    if (sc.film.favorite.length > 0) {
                        if (sc.film.favorite[0].uuid === action.payload) {
                            sc.film.favorite = [];
                        }
                    }
                })
            });
            let response = [...prevState];
            yield put(requestMoviesByCinemaSuccess(response));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getRecommendedMoviesSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getRecommendedMovies, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 200) {
            yield put(getRecommendedMoviesSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* addMovieToFavoriteFromRecommendedSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(addMovieToFavorite, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 201) {
            let prevState = yield select(state => state.movies.recommendedMovies)
            let index = prevState.findIndex(element => element.film_uuid === action.payload);
            prevState[index].favorite.push({ uuid: response.data.data.id });
            const addMovieToFav = [...prevState];
            yield put(getRecommendedMoviesSucceeded(addMovieToFav));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}


function* removeMovieFromFavoriteFromRecommendedSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(removeMovieFromFavorite, action.payload.uuid);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 204) {
            const prevState = yield select(state => state.movies.recommendedMovies);
            let index = prevState.findIndex(element => element.film_uuid === action.payload.film_uuid);
            prevState[index].favorite = [];
            const removeMovieFromFav = [...prevState]
            yield put(getRecommendedMoviesSucceeded(removeMovieFromFav));

        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* addMovieToFavoriteFromBoxOfficeSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(addMovieToFavorite, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 201) {
            let prevState = yield select(state => state.boxoffice.moviesBoxOffice)
            prevState.rows.forEach(item => {
                if (item.film_uuid === action.payload) {
                    item.favorite.push({ uuid: response.data.data.id });
                }
            });
            const addMovieToFav = { ...prevState };
            yield put(moviesBoxOfficeSuccess(addMovieToFav));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* removeMovieToFavoriteFromBoxOfficeSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(removeMovieFromFavorite, action.payload.uuid);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 204) {
            let prevState = yield select(state => state.boxoffice.moviesBoxOffice)
            let index = prevState.rows.findIndex(element => element.film_uuid === action.payload.film_uuid);
            prevState.rows[index].favorite = [];
            const removeMovieFromFav = {...prevState}
            yield put(moviesBoxOfficeSuccess(removeMovieFromFav));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* addMovieToFavoriteFromSoonInCinemaSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(addMovieToFavorite, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 201) {
            let prevState = yield select(state => state.movies.recentMoviesFiltered)   
            let respIndex;
            let filmIndex;
            prevState.resp.map((item, i) => {    
                let index = item.films.findIndex(element => element.film_uuid === action.payload);
                if(index !== -1){
                    respIndex = i;
                    filmIndex = index
                }
            })
            prevState.resp[respIndex].films[filmIndex].favorite.push({ uuid: response.data.data.id });
            const addMovieToFav = { ...prevState };

            yield put(getSoonInCinemaFilteredMoviesSucceeded(addMovieToFav));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}


function* removeMovieFromFavoriteFromSoonInCinema(action) {
    try {
        yield put(showSpinner());
        const response = yield call(removeMovieFromFavorite, action.payload.uuid);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 204) {
             let prevState = yield select(state => state.movies.recentMoviesFiltered)   
            let respIndex;
            let filmIndex;
            prevState.resp.map((item, i) => {    
                let index = item.films.findIndex(element => element.film_uuid === action.payload.film_uuid);
                if(index !== -1){
                    respIndex = i;
                    filmIndex = index
                }
            })
            prevState.resp[respIndex].films[filmIndex].favorite = [];
            const removeMovieFromFav = { ...prevState };

            yield put(getSoonInCinemaFilteredMoviesSucceeded(removeMovieFromFav));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

export default function* moviesSaga() {
    yield takeLatest(GET_SOON_MOVIES, getSoonMoviesSaga);
    yield takeLatest(GET_RECENT_MOVIES, getRecentMoviesSaga);
    yield takeLatest(GET_MOVIE_DETAILS, getMovieDetailsSaga);
    yield takeLatest(ADD_MOVIE_TO_FAVORITE, addMovieToFavoriteSaga);
    yield takeLatest(REMOVE_MOVIE_FROM_FAVORITE, removeMovieFromFavoriteSaga);
    yield takeLatest(SEND_MOVIE_REVIEW, sendMovieReviewSaga);
    yield takeLatest(GET_SOON_IN_CINEMA_MOVIES, getSoonInCinemaMoviesSaga);
    yield takeLatest(GET_MOVIE_TIME_SCHEDULE, getMovieTimeSchedulerSaga);
    yield takeLatest(GET_ALL_MOVIES, getAllMoviesSaga);
    yield takeLatest(GET_ALL_MOVIES_SEE_MORE, getAllMoviesSeeMoreSaga);
    yield takeLatest(ADD_MOVIE_TO_FAVORITE_FROM_ALL_MOVIES, addMovieToFavoriteFromAllMoviesSaga);
    yield takeLatest(REMOVE_MOVIE_FROM_FAVORITE_FROM_ALL_MOVIES, removeMovieFromFavoriteFromAllMoviesSaga);
    yield takeLatest(GET_RECENT_MOVIES_PAGE, getRecentMoviesPageSaga);
    yield takeLatest(ADD_MOVIE_TO_FAVORITE_FROM_RECENT_MOVIES, addMovieToFavoriteFromRecentMoviesSaga);
    yield takeLatest(REMOVE_MOVIE_FROM_FAVORITE_FORM_RECENT_MOVIES, removeMovieFromFavoriteFromRecentMoviesSaga);
    yield takeLatest(GET_RECENT_MOVIES_PAGE_SEE_MORE, getRecentMoviesPageSeeMoreSaga);
    yield takeLatest(ADD_MOVIE_TO_FAVORITE_FROM_HOME_RECENT_MOVIES, addMovieToFavoriteFromHomeRecentMoviesSaga);
    yield takeLatest(REMOVE_MOVIE_FROM_FAVORITE_FROM_HOME_RECENT_MOVIES, removeMovieFromFavoriteFromHomeRecentMoviesSaga);
    yield takeLatest(GET_SOON_IN_CINEMA_FILTERED_MOVIES, getSoonInCinemaFilteredMoviesSaga);
    yield takeLatest(GET_MOVIES_SCHEDULE, getMovieScheduleSaga);
    yield takeLatest(GET_RECENT_MOVIES_SLIDER, getRecentMoviesSliderSaga);
    yield takeLatest(ADD_MOVIE_TO_FAVORITE_FROM_SCHEDULE, addMovieToFavoriteFromScheduleSaga);
    yield takeLatest(REMOVE_MOVIE_FROM_FAVORITE_FROM_SCHEDULE, removeMovieFromFavoriteFromScheduleSaga);
    yield takeLatest(ADD_MOVIE_TO_FAVORITE_FROM_SCHEDULE_CAROUSEL_ITEM, addMovieToFavoriteFromScheduleCarouselItemSaga);
    yield takeLatest(REMOVE_MOVIE_TO_FAVORITE_FROM_SCHEDULE_CAROUSEL_ITEM, removeMovieFromFavoriteFromScheduleCarouselItemSaga);
    yield takeLatest(GET_RECOMMENDED_MOVIES, getRecommendedMoviesSaga);
    yield takeLatest(ADD_MOVIE_TO_FAVORITE_FROM_RECOMMENDED, addMovieToFavoriteFromRecommendedSaga);
    yield takeLatest(REMOVE_MOVIE_FROM_FAVORITE_FROM_RECOMMENDED, removeMovieFromFavoriteFromRecommendedSaga);
    yield takeLatest(ADD_MOVIE_TO_FAVORITE_FROM_BOX_OFFICE, addMovieToFavoriteFromBoxOfficeSaga);
    yield takeLatest(ADD_MOVIE_TO_FAVORITE_FROM_SOON_IN_CINEMA, addMovieToFavoriteFromSoonInCinemaSaga);
    yield takeLatest(REMOVE_MOVIE_FROM_FAVORITE_FROM_SOON_IN_CINEMA, removeMovieFromFavoriteFromSoonInCinema);
    yield takeLatest(REMOVE_MOVIE_FROM_FAVORITE_FROM_BOX_OFFICE, removeMovieToFavoriteFromBoxOfficeSaga);
}



// WEBPACK FOOTER //
// ./src/SHARED/sagas/movies.saga.js